// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetSelfStudyResponseByTypeHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SelfStudyResponseDTO from '../models/SelfStudyResponseDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    selfStudyId: string | null;
    selfStudyResponseTypeId: number;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            selfStudyId: '00000000-0000-0000-0000-000000000000',
            selfStudyResponseTypeId: 0,
        },
        initValues);
    },
    selfStudyId: 'selfStudyId',
    selfStudyResponseTypeId: 'selfStudyResponseTypeId',
}

interface Result extends ResultDTO {
    selfStudyResponse: SelfStudyResponseDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            selfStudyResponse: null,
        },
        initValues);
    },
    selfStudyResponse: 'selfStudyResponse',
}

export { Request, Result };